<template>
  <div v-if="psuList.length > 0 && psuList[0].psexpertid">
    <template v-if="route.path !== '/projectReviewGcTabFile'">
      <div style="display: flex;align-items: center;margin-bottom: 4px;">
        <div style="flex: 1;">
          <span style="margin-right: 8px;">评审会签文件</span>
          <!-- !(+project.projectstatus >= 30) -->
          <el-button type='primary' @click="printForm">
              打印会签空表
          </el-button>
          <el-button v-show="+project.prsflg === 6 || +project.prsflg"  style="float: right;" type="primary" size="small" @click="exportToExcel" icon="el-icon-download">导出EXCEL</el-button>
        </div>
        <!-- <el-button v-show="+project.projectdoneflg === 5 && +project.prsflg === 1" style="float: right;" type="primary" size="small" @click="exportToExcel" icon="el-icon-download">导出EXCEL</el-button> -->
      </div>
      <span v-for="(i,index) in appends" :key="index" style="color:blue;cursor: pointer;">
        <span class="name" @click="downFile(i.appendurl)"><a :src="uploadAddr + i.appendurl">{{i.appendfilename}}</a>
                    </span>
      </span>
    </template>
    <vggrid  :random="Math.floor(Math.random() * 999999)" :list="psuList" tableheight="400" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
    >
    </vggrid>
    <div class="split-line"></div>
    <div v-if="pexpert">
      <project-scoring-com-by-ex :projectid="projectid" :pexpert="pexpert" :pexpertid="pexpert.pexpertid"></project-scoring-com-by-ex>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import ProjectScoringComByEx from './projectScoringComByEx'
  import vggrid from '../../views/common/vggrid'
  import common from '@/mixin/common'
  import utils from '../../assets/js/utils'
  import * as XLSX from 'xlsx'
  import FileSaver from 'file-saver'
  export default {
    name: 'projectScoringSumIndex',
    components: {vggrid, ProjectScoringComByEx},
    mixins: [common],
    props: {
      projectid: {},
      activeName: {}
    },
    data () {
      return {
        pexpert: '',
        project: {},
        appends:[],
        psuList: [],
        pgstList: [],
        pexertList: [],
        btnLoading: false,
        pexpertInfo: {},
        model: {},
        route: this.$route,
        cols: [
          {field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: ''},
          {
            title: '评委评分',
            children: []
          }
        ]
      }
    },
    async mounted () {
      this.pexpert = ''
      await this.getAllpfList()
      await this.getFile()
    },
    watch: {
      async activeName () {
        if(this.activeName === 'pfxm') {
          await this.getAllpfList()
          await this.getFile()
        }
      }
    },
    methods: {
      exportToExcel () {
        // 定义表头和数据
        // 定义表头和数据
        const header = [
          ["", "", "评委评分", "", "", "", "", "", "", ""], // 主表头（行索引0）
          ['供应商',"最终报价","", "", "",'评审分', '价格分' , '履约分','最终得分', '排名'] // 子标题（行索引1）
        ];
        if (this.pexertList.length > 3) {
          let idx = this.pexertList.length - 3
          for (let i = 0; i < idx; i++) {
            header[0].splice(3 + i, 0, '')
            header[1].splice(3 + i, 0, '')
          }
        }
        let tempPsuList = []
        if (this.pexertList.length > 0) {
          for (let i = 0; i < this.pexertList.length; i++) {
            let item = this.pexertList[i]

            header[1][i+2] = item.pexpertname
            tempPsuList = this.psuList.map(psu => {
              psu[item.pexpertname] = this.getCrossCheckResultDesc({pexpertid: item.pexpertid, psucomid: psu.psucomid})
              return psu
            })
          }
        }
        let data = []
        tempPsuList.map((item, index) => {
          let tmp = []
          let obj = {}
          obj['供应商'] = item.comfullname
          obj['最终报价'] = 3333
          obj[item.pexpertname] = item.pgscommercialasexchange
          obj['评审分'] = item.pscommercialasexchange
          obj['价格分'] = item.psppriceasexchange
          if (+this.project.projectdoneflg === 5) {
            obj['履约分'] = item.psuperformanceas
          }
          obj['最终得分'] = item.psas
          obj['排名'] = item.psseq
          tmp.push(item.comfullname)
          if (+this.project.projectquotationmode === 1) {
            tmp.push(utils.comdify(item.psuamt))
          } else {
            tmp.push(item.psupricerate + '%')
          }
          tmp.push(item[header[1][2]])
          tmp.push(item[header[1][3]])
          tmp.push(item[header[1][4]])
          if (this.pexertList.length > 3) {
            let idx = this.pexertList.length - 3
            for (let i = 0; i < idx; i++) {
              tmp.push(item[header[1][4+i+1]])
            }
          }
          tmp.push(item.pscommercialasexchange)
          tmp.push(item.psppriceasexchange)
          if (+this.project.projectdoneflg === 5) {
            tmp.push(item.psuperformanceas)
          }
          tmp.push(item.psas)
          tmp.push(item.psseq)
          data.push(tmp)
        })

        
       
        if (this.project.projectdoneflg === 6) {
        }


        // const  q = [
        //   ["A公司", 90, 85, 88, 92, 95, 89, 91.5, 1],
        //   ["B公司", 88, 90, 85, 89, 92, 87, 89.5, 2]
        // ];
        // 创建工作表对象
        const worksheet = XLSX.utils.aoa_to_sheet([...header, ...data]);

        // 配置合并范围（关键属性）
        // 配置合并范围
        let mergeIdx = Math.max(this.pexertList.length, 3)
        worksheet['!merges'] = [
          // 主标题"项目评分"横向合并（B1-C1）
          { s: { r: 0, c: 2 }, e: { r: 0, c: mergeIdx + 1 } },  // ‌:ml-citation{ref="5" data="citationList"}
        ];

        
        // const max_width = data.reduce((w, r) => Math.max(w, r['供应商'].length), 20);
        worksheet["!cols"] = [{ wch: 20 * 2.2 },{wch: 10}, { wch: 12 } ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // 生成blob对象
        const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })], { type: 'application/octet-stream' });
        var wbout = XLSX.write(workbook, {bookType: "xlsx",bookSST: true,type: "array"});
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          this.project.projectname + "评审表.xlsx"
        )
      },
      async printForm () {
        let {href} = this.$router.resolve({name: 'projectMeetingP', query: {projectid: this.projectid }})
        window.open(href, '_blank')
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      async getAllpfList () {
        this.cols = [
          {field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: ''},
          {
            title: '评委评分',
            children: []
          }
        ]
        this.pexpert = ''
        await this.getModel()
        let data = await request({
          method: 'get',
          url: 'expert/getAllpfList',
          params: {
            projectid: this.projectid,
            project: {projectisqcheck: this.project.projectisqcheck},
            psupqcesresult: 1
          }
        })
        this.psuList = data.psuList
        this.psuList = this.psuList.sort(function(a, b) {
            return a.psseq - b.psseq
        });
        this.pgstList = data.pgstList
        this.pexertList = data.pexertList
        this.setCrossCols(data)
        // this.totalScore(this.pgstList)
      },
      async setCrossCols (res) {
        if (res.pexertList.length > 0) {
          for (let i = 0; i < res.pexertList.length; i++) {
            let item = res.pexertList[i]
            console.log(item, '---c')
            this.cols[1].children.push({
              title:item.pexpertname ==  null?item.pexpertlogincode:item.pexpertname,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return this.getCrossCheckResultDesc({pexpertid: item.pexpertid, psucomid: row.psucomid})
                },
                header: ({ column }) => {
                  return [
                    <div onClick={this.copyValue.bind(this,column,item)} >{item.pexpertname == null ? item.pexpertlogincode : item.pexpertname}</div>,
                    <span onClick={this.viewGc.bind(this,column,item)} style="color: #409EFF;padding-left:5px;cursor: pointer;">查看过程</span>
                  ]
                }
              }
            })
          }
        }
        this.cols.push({field: 'pscommercialasexchange', fieldtype: 'I', title: '评审分',width:100, calculExpr: ''})
        this.cols.push({field: 'psppriceasexchange', fieldtype: 'I', title: '价格分',width:100, calculExpr: ''})
        this.cols.push({field: 'psas', fieldtype: 'I', title: '最终得分',width: 80, calculExpr: ''})
        this.cols.push({field: 'psseq', fieldtype: 'I', title: '排名',width: 80, calculExpr: ''})
        if (+this.project.projectdoneflg === 5) {
          const len = this.cols.length
          this.cols.splice(len - 2, 0, {field: 'psuperformanceas', fieldtype: 'I', title: '履约分',width:100, calculExpr: ''})
        }
        // this.cols.push({
        //   title: '意见',
        //   slots: {
        //     default: 'default',
        //     default: ({row}) => {
        //       return row.psdesc
        //     }
        //   }
        // })
      },
      viewGc (col,item) {
        this.pexpert = item
      },
      getCrossCheckResultDesc (item) {
        let code = this.pgstList.filter(v => +v.pgsexpertid === +item.pexpertid && +v.pgscomid === +item.psucomid)
        let i = code.length > 0 ? code[0].pgscommercialasexchange : ''
        return i
      },
      // totalScore (e) {
      //   let k = 0
      //   for (let i = 0; i < this.psuList.length; i++) {
      //     let sum = 0
      //     for (let j = 0; j < this.pgstList.length; j++) {
      //
      //       if (this.psuList[i].psucomid === this.pgstList[j].pgscomid) {
      //         sum += Number(this.pgstList[j].pgsas)
      //       }
      //     }
      //     this.psuList[i].psas = (sum / this.pexertList.length).toFixed(2)
      //   }
      //   let z = 0
      //   for (let i = 0; i < this.psuList.length; i++) {
      //     for (let j = 0; j < this.psuList.length; j++) {
      //       if (this.psuList[i] && this.psuList[j - 1]) {
      //         if (this.psuList[i].psas < this.psuList[j].psas) {
      //           z++
      //         }
      //       }
      //     }
      //     if (this.psuList[i]) {
      //       this.psuList[i].psseq = z + 1
      //     }
      //     z = 0
      //   }
      //   this.getpsrecList()
      // },
      copyValue(column,item){
        var _input = document.createElement("input");   // 直接构建input
      　　_input.value = item.pexpertname;  // 设置内容
      　　document.body.appendChild(_input);    // 添加临时实例
      　　_input.select();   // 选择实例内容
      　　document.execCommand("Copy");   // 执行复制
      　　document.body.removeChild(_input); // 删除临时实例
      },
      async getFile(){
          this.loading = true
          this.appends = await request({
              method: 'get',
              url: 'ywgl/append/getAppendListByFromId',
              params: {appendfromid:this.project.projectid,
              appendfromtype:24}
          })
          this.loading = false
      },
      async getpsrecList () {
        let prsList = await request({
          method: 'get',
          url: 'expert/getpsrecList',
          params: {psprojectid: this.projectid}
        })

        if (prsList.length > 0) {
          this.psuList.forEach(e => {
            e.psdesc = prsList.filter(v => +v.pscomid === +e.psucomid && +v.psprojectid === +e.psuprojectid)[0].psdesc
          })
        }

      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 30px 0;
  }
</style>
